import {SUBSCRIBE_PLAN_STATE, SubscriptionPlanController} from "./SubscriptionPlanController.js";
import {Router} from "../../../stem-core/src/ui/Router.jsx";
import {
    ADDRESS_PANEL_URL,
    INLINE_GIFT_SUBSCRIPTION_URLS,
    PAYMENT_FAILED_PANEL_URL,
    SUBSCRIPTION_PLAN_PANEL_URL
} from "../PanelConstants.js";
import {Dispatchable} from "../../../stem-core/src/base/Dispatcher.js";
import {apiSubscribe} from "../../../client/state/SubscriptionStore.js";
import {LoadingSpinner} from "../../../core/ui/LoadingSpinner.jsx";
import {CARD_SECTION_STATE, PaymentMethodController} from "./PaymentMethodController.js";
import {Messages} from "../../Messages.js";
import {PaymentMethodStore} from "../../../client/state/PaymentMethodStore.js";
import {ADDRESS_SECTION_STATE} from "../pages/panels/address/AddressPanel.jsx";
import {getSubscribeEndpointPayload} from "./SubscribeFlowState.js";
import {Controller} from "../Controller.js";
import {AddressController} from "./AddressController.js";
import {iFrameState} from "../../services/IFrameState.js";
import {GATE_TYPE, PANEL_TYPE} from "../../../blink-sdk/Constants.js";
import {iFrameAuthService} from "../../services/IFrameAuthService.js";


// TODO @cleanup pasted bullshit from the regular subscription flow
export class GiftSubscriptionFlowState extends Dispatchable {
    giftBeneficiaryEmailAddress = "";
    name = "";
    message = "";

    start() {
        const {panelType, gateType, skipCTA} = iFrameState;

        if (panelType !== PANEL_TYPE.giftSubscription) {
            return;
        }

        Controller.subscriptionPlan = new SubscriptionPlanController({
            subscriptionPlanState: SUBSCRIBE_PLAN_STATE.giftSubscription,
            selectedOffer: null,
            onSelectSuccess: async () => {
                await iFrameAuthService.promptAuthenticationIfNeeded();
                // If we come from login page and switch to review, we want the back to take us to the plans
                // page. Currently, this is how we achieve that without disrupting the flow in any way.
                Router.localHistory.push(SUBSCRIPTION_PLAN_PANEL_URL);
                if (this.giftBeneficiaryEmailAddress) {
                    await this.onGiftDetailsProvided();
                    return;
                }
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.giftDetails);
            }
        });

        if (skipCTA || gateType === GATE_TYPE.popup) {
            Router.changeURL(SUBSCRIPTION_PLAN_PANEL_URL);
        } else {
            Router.changeToCustomPanel();
        }
    }

    async onGiftDetailsProvided() {
        Controller.paymentMethod = new PaymentMethodController({
            cardSectionState: CARD_SECTION_STATE.chooseCard,
            savePaymentMethod: true,
            getScope: () => PaymentMethodStore.Scope.PRIVATE,
            onSelectSuccess: () => this.giftSubscription(),
        });
        if (!Controller.subscriptionPlan.selectedOffer.shouldCollectAddress()) {
            LoadingSpinner.show();
            await Controller.subscriptionPlan.fetchPrices(Controller.address?.selectedAddress);
            LoadingSpinner.hide();
            Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder);
            return;
        }
        Controller.address = new AddressController({
            addressType: Controller.subscriptionPlan.selectedOffer.coverage.requiresAddress ? null : "billing",
            addressSectionState: ADDRESS_SECTION_STATE.chooseAddress,
            onSelectSuccess: async () => {
                await Controller.subscriptionPlan.fetchPrices(Controller.address?.selectedAddress);
                Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.reviewOrder);
            },
            onSelectCancel: () => Router.back(),
            continueLabel: Messages.reviewOrder,
        });
        Router.changeURL(ADDRESS_PANEL_URL);
    }

    async giftSubscription() {
        LoadingSpinner.show();
        try {
            const subscriptionDetails = await getSubscribeEndpointPayload();
            Object.assign(subscriptionDetails.metadata, {
                gift: true,
                giftFrom: this.name,
                giftMessage: this.message,
            });
            await apiSubscribe({
                ...subscriptionDetails,
                gift: true,
                giftBeneficiaryEmailAddress: this.giftBeneficiaryEmailAddress,
            });
        } catch (error) {
            Controller.paymentMethod.update({
                paymentError: error,
            });
            Router.changeURL(PAYMENT_FAILED_PANEL_URL);
            return;
        } finally {
            LoadingSpinner.hide();
        }
        Router.changeURL(INLINE_GIFT_SUBSCRIPTION_URLS.success);
    }
}
